import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const NextIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "next",
  "NextIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16"><g fill="none"><path d="M10.333 8L4.66634 12L4.66634 4L10.333 8Z" fill={colorList[0]} fillOpacity="0.9"/><path d="M11.6663 11.6667L11.6663 4.33335L10.333 4.33335L10.333 11.6667L11.6663 11.6667Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default NextIcon;
